<template>
  <v-card class="d-flex flex-column export-content">
    <v-toolbar
      dark
      color="primary"
      max-height="64px"
      style="z-index: 2;"
      class="pa-0 ma-0 pt-1"
    >
      <v-btn icon dark @click="$emit('closeDialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        SUMMARY VIEW FOR {{ title }}
        <v-divider vertical class="ml-4 mr-4"> </v-divider>

        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip }">
              <v-chip label color="white" class="primary--text title mr-2">{{
                analysis.cohorts.length
              }}</v-chip>
              <span class="white--text text-body-1"
                >Study group{{ analysis.cohorts.length == 1 ? '' : 's' }}</span
              >
            </span>
          </template>
          <span class="subtitle-1">
            {{
              analysis.cohorts
                .map(c => c.label.replace(/^\[O\]_/, ''))
                .join(', ')
            }}
          </span>
        </v-tooltip>

        <v-divider vertical class="ml-4 mr-4"> </v-divider>

        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip }">
              <v-chip label color="white" class="primary--text title mr-2">{{
                analysis.outcomeVariables.length
              }}</v-chip>
              <span class="white--text text-body-1"
                >Variable{{
                  analysis.outcomeVariables.length == 1 ? '' : 's'
                }}</span
              >
            </span>
          </template>
          <span class="subtitle-1">
            {{
              analysis.outcomeVariables.map(ov => ov.abbreviation).join(', ')
            }}
          </span>
        </v-tooltip>

        <v-divider vertical class="ml-4 mr-4"> </v-divider>

        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip }">
              <span class="white--text text-body-1">Analysis Type: </span>
              <v-chip label color="white" class="primary--text title mr-2">{{
                selectedAnalysisMode
              }}</v-chip>
            </span>
          </template>
          <span class="subtitle-1"> {{ selectedAnalysisMode }} Mode </span>
        </v-tooltip>

        <v-divider
          v-if="analysis.collection.is_longitudinal"
          vertical
          class="ml-4 mr-4"
        >
        </v-divider>

        <v-tooltip
          v-if="analysis.collection.is_longitudinal"
          bottom
          color="primary"
        >
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip }">
              <span class="white--text text-body-1">Comparing: </span>
              <v-chip label color="white" class="primary--text title mr-2">{{
                analysis.input.comparisonFieldDescr
              }}</v-chip>
            </span>
          </template>
          <span class="subtitle-1">
            Comparing {{ analysis.input.comparisonFieldLongDescr }}
          </span>
        </v-tooltip>

        <v-divider vertical class="ml-4 mr-4"> </v-divider>

        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip }">
              <span class="white--text text-body-1">Status: </span>
              <v-chip
                label
                :color="statusColor[analysis.status]"
                class="white--text title mr-2"
                >{{ analysis.status }}</v-chip
              >
            </span>
          </template>
          <span v-if="analysis.status == 'Failed'" class="subtitle-1">
            {{ analysis.error }}
          </span>
          <span v-else class="subtitle-1">
            {{ analysis.status }} at {{ analysis.statusTime | formatDate }}
          </span>
        </v-tooltip>

        <v-spacer />

        {{ getAnalysisDescription() }}
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <!-- BUTTONS -->
    <v-container class="text-center mt-3">
      <v-row ref="layoutButtons" justify="center">
        <!-- Layout Buttons -->
        <v-col v-for="(gridOpt, i) in gridOption" :key="'gopt-' + i">
          <v-btn
            block
            medium
            :color="
              gridOpt[0] == selectedGridOption[0] &&
              gridOpt[1] == selectedGridOption[1]
                ? '#ECB1D4'
                : 'primary'
            "
            @mouseenter="showGrid(gridOpt[0], gridOpt[1], $event)"
            @mouseleave="hideGrid"
            @click="displayGrid(gridOpt[0], gridOpt[1])"
          >
            {{ gridOpt[0] }}x{{ gridOpt[1] }}
          </v-btn>
        </v-col>

        <!-- export buttons -->
        <v-col class="text-center" style="display: flex; ">
          <export-interface
            :third-level-parent="true"
            :analysis="analysis"
            export-type="summary_view"
          />
        </v-col>
      </v-row>

      <div
        v-if="gridVisible"
        class="grid-box-container"
        :style="gridPosition"
        @mouseleave="hideGrid"
      >
        <div
          v-for="(row, rowIndex) in gridRows"
          :key="rowIndex"
          class="grid-row"
        >
          <div
            v-for="(col, colIndex) in gridCols"
            :key="colIndex"
            class="grid-box"
          ></div>
        </div>
      </div>
    </v-container>

    <!-- GRID-DISPLAY -->
    <div ref="gridContainer" style=" height: 100% ">
      <!-- for development only -->
      <!-- <div class="layoutJSON">
            Displayed as <code>[x, y, w, h]</code>:
            <div class="columns">
                <div class="layoutItem" v-for="item in layout" :key="item.i">
                    <b>{{item.i}}</b>: [{{item.x}}, {{item.y}}, {{item.w}}, {{item.h}}]
                </div>
            </div>
        </div> -->
      <!--  -->
      <grid-layout
        :layout="layout"
        :col-num="colNum"
        :row-height="1"
        :is-draggable="false"
        :is-resizable="false"
        :use-css-transforms="false"
        :vertical-compact="false"
        :auto-size="true"
        :restore-on-drag="true"
        :responsive="true"
      >
        <grid-item
          v-for="item in layout"
          :key="item.i"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          drag-allow-from=".vue-draggable-handle"
          drag-ignore-from=".no-drag"
          :static="false"
        >
          <dual-button-component
            :analysis="analysis"
            :visible-cohorts="visibleCohorts"
            :boxplot-max-cohorts="analysis.cohorts.length"
            :boxplot-row-height="boxplotRowHeight"
            :boxplot-row-pad="boxplotRowPad"
            :boxplot-bar-pad="boxplotBarPad"
            :boxplot-title-class="boxplotTitleClass"
            :boxplot-export-button-size="boxplotExportButtonSize"
            :initial-selection="item.isel"
            :selected-analysis-mode="selectedAnalysisMode"
            @selectedCohorts="updateVisibleCohorts"
            @cohortColorChange="updateCohortColor"
          ></dual-button-component>
        </grid-item>
      </grid-layout>
    </div>
  </v-card>
</template>

<script>
import logEvent from '@/utils/logging';
import { GridLayout, GridItem } from 'vue-grid-layout';
import DualButtonComponent from '@/components/DataExplorer/DualButtonComponent.vue';
import { actions, state } from '@/store/modules/dataExplorer/types.js';
import { mapState, mapActions } from 'vuex';
import ExportInterface from '@/components/common/ExportInterface.vue';

export default {
  components: {
    GridLayout,
    GridItem,
    DualButtonComponent,
    ExportInterface,
  },
  filters: {
    formatDate(ts) {
      // note that toISOString is going to give us UTC
      return new Date(ts);
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Study Groups',
    },
    analysis: {
      type: Object,
      required: true,
      default: () => {},
    },
    multiSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fullscreen: false,
      expanded: true,
      dialog: false,
      expandAnalytics: true,
      selectedVars: [],
      leftTab1: 1,
      leftTab2: null,
      rightTab1: null,
      rightTab2: null,
      visibleCohorts: [],
      status: 'Submitted',
      error: null,
      statusTime: null,
      statusColor: {
        Submitted: 'primary',
        Running: 'secondary',
        Completed: 'success',
        Failed: 'error',
      },
      pairwiseColorScheme: 'brewer5',
      boxplotRowHeight: 60,
      boxplotRowPad: 12,
      boxplotBarPad: 5,
      boxplotTitleClass: '',
      boxplotExportButtonSize: 'small',

      // Below is JS for Grid-Layout
      layout: [],
      draggable: false,
      resizable: true,
      colNum: 12,
      index: 0,

      // Below is for Button Hover
      gridOption: [
        [1, 1],
        [1, 2],
        [1, 3],
        [2, 1],
        [2, 2],
        [2, 3],
        [3, 1],
        [3, 2],
        [3, 3],
      ],
      selectedGridOption: [0, 0],
      gridVisible: false,
      gridPosition: {},
      gridRows: 0,
      gridCols: 0,
      deleteItems: [], // for delete button
    };
  },
  computed: {
    ...mapState('dataExplorer', {
      screenResize: state.SCREEN_RESIZE,
    }),
    selectedAnalysisMode() {
      // note - don't read from state. infer from cohorts in analysis to display UI changes
      if (
        this.analysis.cohorts.length > 0 &&
        this.analysis.cohorts[0].label.startsWith('[O]_')
      ) {
        return 'Outcome based';
      } else {
        return 'Predictor based';
      }
    },
    outOfDate() {
      let generated_epoch = new Date(this.analysis.statusTime).getTime() * 1.0;
      return (
        this.analysis.status == 'Completed' &&
        generated_epoch < this.analysis.collection.last_modified_epoch
      );
    },
    numOriginalCohorts() {
      return this.analysis.input.cohort_ids.split(',').length;
    },
    cohortsMissing() {
      let n_cohorts_orig = this.numOriginalCohorts;
      let n_cohorts_now = this.analysis.cohorts.length;
      return n_cohorts_orig > n_cohorts_now;
    },
    sortedOutcomeVariables() {
      let ab2pv = {};
      this.analysis.pvals.forEach(pv => {
        ab2pv[pv.abbreviation] = pv.pval;
      });

      let ovs = Array.from(this.analysis.outcomeVariables);
      ovs.sort(function(a, b) {
        let a_pv = ab2pv[a.abbreviation];
        let b_pv = ab2pv[b.abbreviation];
        return a_pv > b_pv ? 1 : a_pv < b_pv ? -1 : 0;
      });
      return ovs;
    },
  },
  watch: {
    // screenResize(){
    //   this.simulateClick();
    // },
    analysis(a) {
      if (a != null) {
        this.visibleCohorts = this.analysis.cohorts;
      }
    },
    'analysis.cohorts': function() {
      // propagate change to child components
      if (this.visibleCohorts.length > 0) {
        this.visibleCohorts.splice(0, 1, this.visibleCohorts[0]);
      }
    },
    leftTab1(lt) {
      logEvent(
        this.$gtag,
        null,
        null,
        'left_tab_changeto_' + lt,
        'analysis',
        'analysis ' + this.analysis.index + ' '
      );
    },
    leftTab2(lt) {
      logEvent(
        this.$gtag,
        null,
        null,
        'left_tab_changeto_' + lt,
        'analysis',
        'analysis ' + this.analysis.index + ' '
      );
    },
    rightTab1(rt) {
      const dv = this.$refs.dview;
      if (dv) dv.map(c => c.onResize());

      logEvent(
        this.$gtag,
        null,
        null,
        'right_tab_changeto_' + rt,
        'analysis',
        'analysis ' + this.analysis.index + ' '
      );
    },
    rightTab2(rt) {
      const bp = this.$refs.boxplots;
      const sb = this.$refs.stackedbars;
      setTimeout(async function() {
        if (bp) bp.map(c => c.onResize());
        if (sb) sb.map(c => c.onResize());
      }, 500);

      logEvent(
        this.$gtag,
        null,
        null,
        'right_tab_changeto_' + rt,
        'analysis',
        'analysis ' + this.analysis.index + ' '
      );
    },
  },
  created() {
    if (this.analysis != null) {
      this.visibleCohorts = this.analysis.cohorts;
    }

    window.addEventListener('resize', this.simulateClick);
  },
  mounted() {
    this.$nextTick(() => {
      const dv = this.$refs.dview;
      if (dv) dv.map(c => c.onResize());

      const bp = this.$refs.boxplots;
      const sb = this.$refs.stackedbars;
      if (bp) bp.map(c => c.onResize());
      if (sb) sb.map(c => c.onResize());
    });
    // Below is JS for Grid-Layout
    this.index = this.layout.length;
    // preset default layout (best on wide screens)
    if (this.layout.length == 0) {
      this.$nextTick(() => {
        let firstVar = this.sortedOutcomeVariables[0];
        let initialSelections = {
          '2': {
            label: firstVar.abbreviation,
            value: 'boxplot->' + firstVar.abbreviation,
          },
          '3': { label: 'Summary of Results', value: 'Summary of Results' },
        };
        if (this.selectedAnalysisMode == 'Predictor based') {
          initialSelections['1'] = {
            label: 'Study groups',
            value: 'Predictors',
          };
          initialSelections['4'] = {
            label: 'Outcome Variables',
            value: 'Outcome Variables',
          };
        } else {
          initialSelections['1'] = { label: 'Study groups', value: 'Outcomes' };
          initialSelections['4'] = {
            label: 'Predictor Variables',
            value: 'Predictor Variables',
          };
        }
        if (this.analysis.collection.is_longitudinal) {
          initialSelections['5'] = {
            label: firstVar.abbreviation,
            value: 'longitudinalGraph->' + firstVar.abbreviation,
          };
        }
        this.displayGrid(2, 3, initialSelections);
      });
    }

    // simulate a click on the selected layout button
    setTimeout(this.simulateClick, 1000);

    // Get a reference to the <html> element
    const htmlElement = document.documentElement;

    // Change the CSS properties of the <html> element
    htmlElement.style.overflow = 'hidden'; // Disable overflow
  },
  beforeDestroy() {
    // Get a reference to the <html> element
    const htmlElement = document.documentElement;
    // Change the CSS properties of the <html> element
    htmlElement.style.overflow = 'auto'; // Enable overflow
  },
  methods: {
    ...mapActions('dataExplorer', {
      setScreenResize: actions.SET_SCREEN_RESIZE,
    }),

    simulateClick() {
      this.displayGrid(this.selectedGridOption[0], this.selectedGridOption[1]);
      // // console.log(this.selectedGridOption)
      // let selectedButton = this.$refs.layoutButtons;
      // let selectedButtonRow = this.selectedGridOption[0];
      // let selectedButtonCol = this.selectedGridOption[1];
      // //iterate through all buttons
      // for (let i = 0; i < selectedButton.children.length; i++) {
      //   let buttonRow = selectedButton.children[i].children[0].innerText[0];
      //   let buttonCol = selectedButton.children[i].children[0].innerText[2];
      //   if (
      //     buttonRow == selectedButtonRow &&
      //     buttonCol == selectedButtonCol
      //   ) {
      //     console.log(selectedButton.children[i])
      //     selectedButton.children[i].children[0].click();
      //   }
      // }
      // console.log(selectedButton);
      // [
      //   this.selectedGridOption[0] * 3 + this.selectedGridOption[1] - 4
      // ];
      // selectedButton.click();
    },

    // ----------------------------------------------------------------
    // Displaying Grid Layout when Hover over Buttons
    showGrid(rows, cols, event) {
      const targetButton = event.target;
      const buttonRect = targetButton.getBoundingClientRect();

      this.gridVisible = true;
      this.gridRows = rows;
      this.gridCols = cols;

      this.gridPosition = {
        top: `${buttonRect.top + buttonRect.height + 10}px`,
        left: `${buttonRect.left + 10}px`,
      };
    },
    hideGrid() {
      this.gridVisible = false;
      this.gridRows = 0;
      this.gridCols = 0;
    },
    // setScreenResizeFalse(){
    //   this.setScreenResize(this.screenResize);
    // },
    // ----------------------------------------------------------------
    // this function changes this.layout to the grid layout that is selected

    displayGrid(row, col, initialSelections) {
      //calculate row height based on row number
      const containerRef = this.$refs.gridContainer;
      const containerHeight = containerRef.clientHeight;
      const rowHeight = Math.floor(containerHeight / row / 11.1); //floor int
      // console.log("containerHeight: ",containerHeight);
      // console.log("rowHeight: ",rowHeight);

      //iterativelly add grid items to this.layout
      this.layout = [];
      // random number between 0-100
      let counter = 0;
      for (let i = 0; i < row; i++) {
        for (let j = 0; j < col; j++) {
          let tempY = i * 12;
          let tempW = 12 / col;
          let tempX = j * tempW;
          counter++;
          let counterStr = counter.toString();
          let tempSingleLayoutObject = {
            x: tempX,
            y: tempY,
            w: tempW,
            h: rowHeight,
            i: counterStr,
          };
          if (initialSelections != null && counterStr in initialSelections) {
            tempSingleLayoutObject['isel'] = initialSelections[counterStr];
          }
          // console.log(tempSingleLayoutObject)
          this.layout.push(tempSingleLayoutObject);
        }
      }

      //call state action
      this.setScreenResize(!this.screenResize);
      let secLayer = this.$children[this.$children.length - 1];
      let thirdLayer =
        secLayer.$children[secLayer.$children.length - 1].$children;
      thirdLayer = [...thirdLayer];
      thirdLayer.shift();
      this.selectedGridOption = [row, col];
      //console.log(thirdLayer)
      // setTimeout(this.setScreenResizeFalse, 2000);
    },

    // ----------------------------------------------------------------

    variableSelected(sv) {
      // only outcome variables can be selected
      if ('flip_axis' in sv) {
        this.selectedVars = [sv];
      }
    },
    variablesSelected(nv) {
      // only outcome variables can be selected
      this.selectedVars = nv.filter(v => 'flip_axis' in v);
    },
    analyticsExpandClicked(nv) {
      this.expandAnalytics = nv;
    },
    updateVisibleCohorts(vc) {
      // keep visibleCohorts sorted in the same order as cohorts
      var vcids = {};
      vc.forEach(c => {
        vcids[c.id] = true;
      });
      this.visibleCohorts = this.analysis.cohorts.filter(c => vcids[c.id]);
    },
    deleteAnalysis() {
      this.$emit('deleteAnalysis');
    },
    getComparisonFieldDescription(cfield) {
      const descrs = {
        change: 'Change from first visit - last visit',
        firstVisit: 'First visit',
        lastVisit: 'Last visit',
      };
      return descrs[cfield];
    },
    splitPane1Resized(evt) {
      var psize = evt[0].size;
      this.expandAnalytics = psize > 30;
      if (this.$refs.dview) {
        this.$refs.dview.map(c => c.onResize());
      }
    },
    splitPane2Resized() {
      this.$nextTick(() => {
        if (this.$refs.boxplots) this.$refs.boxplots.map(c => c.onResize());
        if (this.$refs.stackedbars)
          this.$refs.stackedbars.map(c => c.onResize());
      });
    },
    updateCohortColor(cc) {
      // propagate event
      this.$emit('cohortColorChange', {
        cohort: cc['cohort'],
        color: cc['color'],
        pattern: cc['pattern'],
      });
    },
    getAnalysisDescription() {
      let dl2descr = {
        left_y_axis: 'First visit',
        right_y_axis: 'Last visit',
        change: 'First - Last visit change',
      };

      // predictor variables used
      let predVars = {};
      this.analysis.cohorts.forEach(c => {
        const queries = c.queries;
        queries.forEach(q => {
          let dl_lbl = q.input_variable.dimension_label
            ? ' - ' + dl2descr[q.input_variable.dimension_label]
            : '';
          if ('subject_ontology' in q.input_variable) {
            predVars[q.input_variable.subject_ontology.label + dl_lbl] = 1;
          } else if ('observation_ontology' in q.input_variable) {
            predVars[q.input_variable.observation_ontology.label + dl_lbl] = 1;
          }
        });
      });

      if (this.selectedAnalysisMode == 'Predictor based') {
        return 'Predictors: ' + Object.keys(predVars).join(' and ');
      } else {
        return 'Outcomes: ' + Object.keys(predVars).join(' and ');
      }
    },
  },
};
</script>
<style scoped>
table.v-data-table thead tr th {
  font-size: 24px;
}
table.v-data-table tbody tr td {
  font-size: 24px;
}
div.s_pane {
  background-color: white !important;
  overflow-y: auto;
}

.default-theme {
  display: none;
}

v-footer {
  height: 8rem;
  display: flex;
  justify-content: center;
  /* align-content: center; */
  align-items: center;
}

/* Below is CSS for Grid-Layout */
/*************************************/

.layoutJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}

/*************************************/

.overflowYes {
  overflow: auto;
}

.remove {
  position: absolute;
  right: 10px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: white;
  border: 1px solid black;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 1.1rem;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  /* position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    right: 0; */
  padding: 0 8px 8px 0;
  /* background-origin: content-box;
    background-color: black;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer; */
}

.draggableArea {
  /* position:absolute; */
  top: -45px;

  width: 100%;
}
.draggableTitle {
  /* 50% opacity black background */
  background-color: rgb(204, 195, 195);
  cursor: move;
  /* move cursor */
}

/*************************************/
.grid-box-container {
  position: fixed;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000;
}
.grid-row {
  display: flex;
  justify-content: center;
}
.grid-box {
  width: 40px;
  height: 40px;
  background-color: black;
  margin: 2px;
}
</style>
